// src/modules/app-views/toolbox/pages/Ai/components/EmptyState.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Card } from 'antd';
import ToolboxAiHeader from './ToolboxAiHeader';
import InputForm from './InputForm';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
/**
 * EmptyState - Initial prompt screen with form
 */
const EmptyState = ({
  formRef,
  lastFormValues,
  selectedModel,
  aiModels,
  creditsInfo,
  isMobile,
  onModelChange,
  onFinish,
  onBackToWelcome,
  onOpenCreditsDrawer,
}) => {
  // ---------------------------------------------------------------------------
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 2. HOOKS & REFS
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 3. LOCAL VARIABLES I
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 4. LOCAL STATE
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 5. EFFECTS
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 6. HANDLERS
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 7. LOCAL VARIABLES II
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 8. UI
  // ---------------------------------------------------------------------------
  return (
    <ToolboxAiHeader isMobile={isMobile}>
      <Card style={{ width: '100%', maxWidth: 580 }}>
        <InputForm
          formRef={formRef}
          isChatMode={false}
          lastFormValues={lastFormValues}
          selectedModel={selectedModel}
          aiModels={aiModels}
          creditsInfo={creditsInfo}
          isMobile={isMobile}
          onModelChange={onModelChange}
          onFinish={onFinish}
          onBackToWelcome={onBackToWelcome}
          onOpenCreditsDrawer={onOpenCreditsDrawer}
        />
      </Card>
    </ToolboxAiHeader>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default EmptyState;
